import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Grid, Button } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast, ToastContainer } from "react-toastify";

const headerCellStyle = {
  position: "sticky",
  top: 0,
  background: "#f2f2f2",
  color: "black",
  padding: "8px",
  border: "1px solid #ccc",
  zIndex: 2, 
};

const cellStyle = {
  padding: "8px",
  border: "1px solid #ccc",
};

function ItemMaster(props) {
  const [items, setItems] = useState([]);

  const [ItCode, setItCode] = useState("");
  const [ItemCode, setItemCode] = useState("");
  const [ItName, setItName] = useState("");
  const [GradeCode, setGradeCode] = useState("");
  const [Grade, setGrade] = useState("");
  const [SubAcCode, setSubAcCode] = useState(0);
  const [SubAcHead, setSubAcHead] = useState("");
  const [initialData, setInitialData] = useState([]);

  const [ItemSubGroupCode, setItemSubGroupCode] = useState(0);
  const [ItemSubGroupName, setItemSubGroupName] = useState("");
  const [ItemCategoryCode, setItemCategoryCode] = useState(0);
  const [ItemCategoryName, setItemCategoryName] = useState("");
  const [UnitId, setUnitId] = useState(0);
  const [UnitName, setUnitName] = useState("");
  const [PackingCode, setPackingCode] = useState(0);
  const [PackingName, setPackingName] = useState("");
  const [LocationCode, setLocationCode] = useState(0);
  const [LocationName, setLocationName] = useState("");
  const [HSNCODE, setHSNCODE] = useState("");
  const [GstRateCode, setGstRateCode] = useState(0);
  const [GstRate, setGstRate] = useState(0);
  const [BoxWeight, setBoxWeight] = useState("");
  const [ProdnWeight, setProdnWeight] = useState("");
  const [SalesWeight, setSalesWeight] = useState("");
  const [RRWeight, setRRWeight] = useState("");
  const [BoringWeight, setBoringWeight] = useState("");
  const [QtyPerBox, setQtyPerBox] = useState(0);
  const [CostRate, setCostRate] = useState("");
  const [Remark1, setRemark1] = useState("");
  const [Remark2, setRemark2] = useState("");
  const [Remark3, setRemark3] = useState("");
  const [UserID, setUserID] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState("add");
  const [editItemId, setEditItemId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);

  const [itemMasterEntries, setItemMasterEntries] = useState([]);

  const [selectedSubGroup, setSelectedSubGroup] = useState("");

  const [itemSubGroup, setItemSubGroup] = useState([]);
  const [itemCategory, setItemCategory] = useState([]);
  const [unit, setUnit] = useState([]);
  const [packing, setPacking] = useState([]);
  const [location, seLocation] = useState([]);
  const [gstRates, setGstRates] = useState([]);
  const [ledgerEntries, setLedgerEntries] = useState([]);
  const [subledgerEntries, setSubLedgerEntries] = useState([]);
  const [gradeEntries, setGradeEntries] = useState([]);
  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [debouncedCode, setDebouncedCode] = useState(ItCode);

  useEffect(() => {
    fetchItemMaster();
    fetchItemSubGroup();
    fetchItemCategory();
    fetchUnit();
    fetchPacking();
    fetchLocation();
    fetchGSTMaster();
    fetchLedgerMaster();
    fetchSubLedgerMaster();
    fetchGradeMaster();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(ItCode);
    }, 300);

    return () => clearTimeout(handler);
  }, [ItCode]);

  useEffect(() => {
    if (formMode === 'add') {
      if (!debouncedCode) return;

      const exists = itemMasterEntries.some(item => item.ItCode === debouncedCode);
      console.log("check", debouncedCode, exists);
      if (exists) {
        toast.error("ItCode already exists! Please enter unique ItCode.", { autoClose: 900 });
      }
    }
  }, [debouncedCode, itemMasterEntries, formMode]);

  const fetchItemMaster = async () => {
    try {
      const response = await axios.get(
        "https://www.wingap.net.in/api/items-master"
      );
      setItemMasterEntries(response.data);
      /* const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setItCode(nextEntryNo); */
      setInitialData(response.data);
      // console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.ItCode > maxEntryNo) {
        maxEntryNo = entry.ItCode;
      }
    }
    return maxEntryNo;
  };

  const fetchGradeMaster = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/grade");
      setGradeEntries(response.data);
      // console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get(
        "https://www.wingap.net.in/api/subledgerMaster"
      );
      setSubLedgerEntries(response.data);
      // console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchItemSubGroup = async () => {
    try {
      const response = await axios.get(
        "https://www.wingap.net.in/api/itemsubgroups"
      );
      setItemSubGroup(response.data);
      // console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchItemCategory = async () => {
    try {
      const response = await axios.get(
        "https://www.wingap.net.in/api/itemcategories"
      );
      setItemCategory(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchUnit = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/units");
      setUnit(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchPacking = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/packing");
      setPacking(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchLocation = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/locations");
      seLocation(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchGSTMaster = async () => {
    try {
      const response = await axios.get("https://www.wingap.net.in/api/gstrates");
      setGstRates(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const fetchLedgerMaster = async () => {
    try {
      const response = await axios.get(
        "https://www.wingap.net.in/api/ledger-master"
      );
      setLedgerEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log("error:", error);
    }
  };

  // Get unique subgroups for dropdown
  const uniqueSubGroups = [...new Set(
    itemSubGroup.map(entry => ({
      code: entry.ItemSubGroupCode,
      name: entry.ItemSubGroupName
    }))
  )];

  const addItem = async () => {
    if ((!props.canAdd)) {
      const action = "Save";
      toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
      return;
    }
    const isDuplicate = itemMasterEntries.some(item => item.ItCode == ItCode);

    if (isDuplicate) {
      toast.error("ItCode already exists! Please enter a unique ItCode.", { autoClose: 900 });
      setItCode('');
      return;
    }
    if (!ItName.trim()) {
      toast.warn("Error: Item Name is required.", { autoClose: 700 });
      return; // Exit the function early
    }
    try {
      await axios.post("https://www.wingap.net.in/api/items-master", {
        ItCode: ItCode,
        ItName: ItName,
        ItemCode: ItemCode,
        GradeCode: GradeCode,
        SubAcCode: SubAcCode,
        ItemSubGroupCode: ItemSubGroupCode,
        ItemCategoryCode: ItemCategoryCode,
        UnitCode: UnitId,
        PackingCode: PackingCode,
        LocationCode: LocationCode,
        HSNCODE: HSNCODE,
        GstRateCode: GstRateCode,
        QtyPerBox: QtyPerBox,
        CostRate: CostRate,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        UserID: props.name,
      });
      fetchItemMaster();
      setItCode("");
      setItName("");
      setItemCode("");
      setGradeCode(gradeEntries[0].GradeCode);
      setSubAcCode(subledgerEntries[0].SubAcCode);
      setItemSubGroupCode(itemSubGroup[0].ItemSubGroupCode);
      setItemCategoryCode(itemCategory[0].ItemCategoryCode);
      setUnitId(unit[0].UnitId);
      setPackingCode(packing[0].PackingCode);
      setLocationCode(location[0].LocationCode);
      setGstRateCode(gstRates[0].GSTRateCode);
      setHSNCODE("");
      setQtyPerBox("");
      setCostRate("");
      setRemark1("");
      setRemark2("");
      setRemark3("");
      setUserID("");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const updateItem = async (ItCode) => {
    if ((!props.canEdit)) {
      const action = "Update";
      toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
      return;
    }
    /* const isDuplicate = itemMasterEntries.some(item => item.ItCode == ItCode);

    if (isDuplicate) {
      toast.error("ItCode already exists! Please enter a unique ItCode.", { autoClose: 900 });
      setItCode('');
      return;
    } */
    if (!ItName.trim()) {
      toast.warn("Error: Item Name is required.", { autoClose: 700 });
      return;
    }
    try {
      await axios.put(`https://www.wingap.net.in/api/items-master/${ItCode}`, {
        ItemCode: ItemCode,
        ItName: ItName,
        GradeCode: GradeCode,
        SubAcCode: SubAcCode,
        ItemSubGroupCode: ItemSubGroupCode,
        ItemCategoryCode: ItemCategoryCode,
        UnitCode: UnitId,
        PackingCode: PackingCode,
        LocationCode: LocationCode,
        HSNCODE: HSNCODE,
        GstRateCode: GstRateCode,
        QtyPerBox: QtyPerBox,
        CostRate: CostRate,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        UserID: props.name,
      });
      fetchItemMaster();
      setItCode("");
      setItName("");
      setItemCode("");
      setGradeCode(gradeEntries[0].GradeCode);
      setSubAcCode(subledgerEntries[0].SubAcCode);
      setItemSubGroupCode(itemSubGroup[0].ItemSubGroupCode);
      setItemCategoryCode(itemCategory[0].ItemCategoryCode);
      setUnitId(unit[0].UnitId);
      setPackingCode(packing[0].PackingCode);
      setLocationCode(location[0].LocationCode);
      setGstRateCode(gstRates[0].GSTRateCode);
      setHSNCODE("");
      setQtyPerBox("");
      setCostRate("");
      setRemark1("");
      setRemark2("");
      setRemark3("");
      setUserID("");
      setFormMode("add");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteItem(deleteEntryNo.ItCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const deleteItem = async (ItCode) => {
    if (!props.canDelete) {
      toast.error("You do not have permission to Delete.", { autoClose: 800 });
      return;
    }
    try {
      const response = await axios.delete(
        `https://www.wingap.net.in/api/items-master/${ItCode}`,
        {
          headers: {
            username: props.name,
          },
        }
      );

      if (response.status === 200) {
        fetchItemMaster();
      }
    } catch (error) {
      console.log("Error:", error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage("Permission Denied");
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage(
          "An error occurred while deleting the account group. Please try again later."
        );
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error("Error:", error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    setErrorMessage("");
  };

  const setEditForm = (item) => {
    setFormMode("edit");
    setItCode(item.ItCode);
    setItemCode(item.PartNo);
    setItName(item.ItName);
    setGradeCode(item.GradeCode);
    setSubAcCode(item.SubAccode);
    setItemSubGroupCode(item.ItemSubGroupCode);
    setItemCategoryCode(item.ItemCategoryCode);
    setUnitId(item.UnitCode);
    setPackingCode(item.PackingCode);
    setLocationCode(item.LocationCode);
    setHSNCODE(item.HSNCODE);
    setGstRateCode(item.GSTRATECODE);
    setQtyPerBox(item.QtyPerBox);
    setCostRate(item.CostRate);
    setRemark1(item.Remark1);
    setRemark2(item.Remark2);
    setRemark3(item.Remark3);
    setUserID(item.USERID);

    setShowGrid(false);
    const selectedGroup = itemSubGroup.find(
      (group) => group.ItemSubGroupCode === item.ItemSubGroupCode
    );
    if (selectedGroup) {
      setItemSubGroupName(selectedGroup.ItemSubGroupName);
    }
    const selectedGroup1 = itemCategory.find(
      (group) => group.ItemCategoryCode === item.ItemCategoryCode
    );
    if (selectedGroup1) {
      setItemCategoryName(selectedGroup1.ItemCategoryName);
    }
    const selectedGroup3 = unit.find((group) => group.UnitId === item.UnitCode);
    if (selectedGroup3) {
      setUnitName(selectedGroup3.UnitName);
    }
    const selectedGroup4 = packing.find(
      (group) => group.PackingCode === item.PackingCode
    );
    if (selectedGroup4) {
      setPackingName(selectedGroup4.PackingName);
    }
    const selectedGroup5 = location.find(
      (group) => group.LocationCode === item.LocationCode
    );
    if (selectedGroup5) {
      setLocationName(selectedGroup5.LocationName);
    }
    const selectedGroup6 = gradeEntries.find(
      (group) => group.GradeCode === item.GradeCode
    );
    if (selectedGroup6) {
      setGradeCode(selectedGroup6.GradeCode);
    }
    const selectedGroup7 = subledgerEntries.find(
      (group) => group.SubAcCode === item.SubAcCode
    );
    if (selectedGroup7) {
      setSubAcHead(selectedGroup7.SubAcHead);
    }
    const selectedGroup8 = gstRates.find(
      (group) => group.GSTRateCode === item.GSTRATECODE
    );
    if (selectedGroup8) {
      setGstRate(selectedGroup8.GSTPercent);
    }
  };

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setItems(items);
    handleCancel();
  };

  const handleCancel = () => {
    setFormMode("add");
    setEditItemId("");
    setItCode("");
    setItName("");
    setItemCode("");
    setDebouncedCode('');
    setGradeCode(gradeEntries[0].GradeCode);
    setSubAcCode(subledgerEntries[0].SubAcCode);
    setItemSubGroupCode(itemSubGroup[0].ItemSubGroupCode);
    setItemCategoryCode(itemCategory[0].ItemCategoryCode);
    setUnitId(unit[0].UnitId);
    setPackingCode(packing[0].PackingCode);
    setLocationCode(location[0].LocationCode);
    setGstRateCode(gstRates[0].GSTRateCode);
    setHSNCODE('');
    setQtyPerBox("");
    setCostRate("");
    setRemark1("");
    setRemark2("");
    setRemark3("");
    setUserID("");
    fetchItemMaster();
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ItemData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const handleSearch = (searchQuery) => {
    if (!searchQuery) {
      setItemMasterEntries(initialData);
    } else {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = initialData.filter((entry) => {
        const partycode = entry.ItCode;

        const partyNameEntry = initialData.find(
          (partyEntry) => partyEntry.ItCode === partycode
        );
        const partyName = partyNameEntry ? partyNameEntry.ItName.toLowerCase() : '';
        return partyName.includes(lowercasedQuery);
      });
      setItemMasterEntries(filtered);
    }
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery]);

  return (
    <div style={{ maxWidth: "100%", margin: "0 auto", padding: "20px" }}>
      <ToastContainer />
      <h1 style={{ fontSize: "24px", marginBottom: "10px" }}>Item Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{
            backgroundColor: showGrid ? "#4caf50" : "blue",
            color: "white",
            marginBottom: "20px",
            float: "right",
          }}
        >
          {showGrid ? "Add" : "Back"}
        </Button>
      </Grid>
      {showGrid && (
        <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{
              backgroundColor: "yellow",
              color: "black",
              marginBottom: "20px",
              float: "right",
              marginRight: "10px",
            }}
          >
            Download PDF
          </Button>
        </Grid>
      )}
      {!showGrid && (
        <>
          <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
            {formMode === "add" ? "Add" : "Edit"}
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="ItCode"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                ItCode
              </label>
              <input
                type="text"
                value={ItCode}
                onChange={(e) => setItCode(e.target.value)}
                //readOnly
                placeholder="ItCode"
                style={{ marginBottom: "5px", padding: "5px", width: "12%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="Item"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Item Code
              </label>
              <input
                type="text"
                value={ItemCode}
                onChange={(e) => setItemCode(e.target.value)}
                placeholder="Code"
                style={{ marginBottom: "5px", padding: "5px", width: "12%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="ItName"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Item Name
              </label>
              <input
                type="text"
                value={ItName}
                onChange={(e) => setItName(e.target.value)}
                placeholder="Item Name"
                style={{ marginBottom: "5px", padding: "5px", width: "45%" }}
                list="itemNames"
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="Grade"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Grade
              </label>
              <select
                value={GradeCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setGradeCode(selectedGroupName);
                  const selectedGroup = gradeEntries.find(
                    (group) => group.GradeCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setGradeCode(selectedGroup.GradeCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                {gradeEntries.map((group) => (
                  <option key={group.GradeCode} value={group.GradeCode}>
                    {group.Grade}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={GradeCode}
                onChange={(e) => setGradeCode(e.target.value)}
                placeholder="GradeCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            {/* SubAcCode */}
            {/* <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="SubAcHead" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>SubAcHead</label>
              <select
                value={SubAcHead}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setSubAcHead(selectedGroupName);
                  const selectedGroup = subledgerEntries.find(group => group.SubAcHead === selectedGroupName);
                  if (selectedGroup) {
                    setSubAcCode(selectedGroup.SubAcCode);
                  }
                }}
                style={{ marginBottom: '5px', padding: '5px', width: '25%' }}
              >
                {subledgerEntries.map((group) => (
                  <option key={group.SubAcCode} value={group.SubAcCode}>{group.SubAcHead}</option>
                ))}
              </select>
              <input
                type="number"
                value={SubAcCode}
                onChange={(e) => {
                  setSubAcCode(e.target.value);
                  // Find the corresponding SubAcHead based on entered SubAcCode
                  const correspondingGroup = subledgerEntries.find(group => group.SubAcCode === e.target.value);
                  if (correspondingGroup) {
                    setSubAcHead(correspondingGroup.SubAcHead);
                  } else {
                    setSubAcHead(''); // Set to an appropriate default value when there's no match
                  }
                }}
                placeholder="SubAcCode"
                style={{ marginLeft: '10px', marginBottom: '5px', padding: '4px', width: '7%' }}
              />
          </div> */}
            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="SubAcHead"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                SubAcHead
              </label>
              <select
                value={SubAcCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setSubAcCode(selectedGroupName);
                  const selectedGroup = subledgerEntries.find(
                    (group) => group.SubAcCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setSubAcCode(selectedGroup.SubAcCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Party </option>
                {subledgerEntries.map((group) => (
                  <option key={group.SubAcCode} value={group.SubAcCode}>
                    {group.SubAcHead}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={SubAcCode}
                onChange={(e) => {
                  setSubAcCode(e.target.value);

                  const correspondingGroup = subledgerEntries.find(
                    (group) => group.SubAcCode === e.target.value
                  );
                  if (correspondingGroup) {
                    setSubAcHead(correspondingGroup.SubAcHead);
                  } else {
                    setSubAcHead("");
                  }
                }}
                placeholder="SubAcCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="ItemSubGroupName"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                ItemSubGroupName
              </label>
              <select
                value={ItemSubGroupCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setItemSubGroupCode(selectedGroupName);
                  const selectedGroup = itemSubGroup.find(
                    (group) => group.ItemSubGroupCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setItemSubGroupCode(selectedGroup.ItemSubGroupCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Item SubGroup </option>
                {itemSubGroup.map((group) => (
                  <option
                    key={group.ItemSubGroupCode}
                    value={group.ItemSubGroupCode}
                  >
                    {group.ItemSubGroupName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={ItemSubGroupCode}
                onChange={(e) => setItemSubGroupCode(e.target.value)}
                placeholder="ISGCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="ItemCategoryCode"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                ItemCategoryName
              </label>
              <select
                value={ItemCategoryCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setItemCategoryCode(selectedGroupName);
                  const selectedGroup = itemCategory.find(
                    (group) => group.ItemCategoryCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setItemCategoryCode(selectedGroup.ItemCategoryCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Item Category </option>

                {itemCategory.map((group) => (
                  <option
                    key={group.ItemCategoryCode}
                    value={group.ItemCategoryCode}
                  >
                    {group.ItemCategoryName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={ItemCategoryCode}
                onChange={(e) => setItemCategoryCode(e.target.value)}
                placeholder="ICCCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="UnitId"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                UnitName
              </label>
              <select
                value={UnitId}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setUnitId(selectedGroupName);
                  const selectedGroup = unit.find(
                    (group) => group.UnitId === selectedGroupName
                  );
                  if (selectedGroup) {
                    setUnitId(selectedGroup.UnitId);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Unit </option>

                {unit.map((group) => (
                  <option key={group.UnitId} value={group.UnitId}>
                    {group.UnitName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={UnitId}
                onChange={(e) => setUnitId(e.target.value)}
                placeholder="UnitId"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="PackingName"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                PackingName
              </label>
              <select
                value={PackingCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setPackingCode(selectedGroupName);
                  const selectedGroup = packing.find(
                    (group) => group.PackingCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setPackingCode(selectedGroup.PackingCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Packing </option>

                {packing.map((group) => (
                  <option key={group.PackingCode} value={group.PackingCode}>
                    {group.PackingName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={PackingCode}
                onChange={(e) => setPackingCode(e.target.value)}
                placeholder="PCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="LocationName"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                LocationName
              </label>
              <select
                value={LocationCode}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setLocationCode(selectedGroupName);
                  const selectedGroup = location.find(
                    (group) => group.LocationCode === selectedGroupName
                  );
                  if (selectedGroup) {
                    setLocationCode(selectedGroup.LocationCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              >
                <option key='' value=''> Select Loction </option>

                {location.map((group) => (
                  <option key={group.LocationCode} value={group.LocationCode}>
                    {group.LocationName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={LocationCode}
                onChange={(e) => setLocationCode(e.target.value)}
                placeholder="LCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="HSNCODE"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                HSNCODE
              </label>
              <input
                type="text"
                value={HSNCODE}
                onChange={(e) => setHSNCODE(e.target.value)}
                placeholder="HSNCODE"
                style={{ marginBottom: "5px", padding: "5px", width: "25%" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="GstRate"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                GstRate
              </label>
              <select
                value={GstRate}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setGstRate(selectedGroupName);
                  const selectedGroup = gstRates.find(
                    (group) => group.GSTPercent == selectedGroupName
                  );
                  console.log(selectedGroup);
                  if (selectedGroup) {
                    setGstRateCode(selectedGroup.GSTRateCode);
                  }
                }}
                style={{ marginBottom: "5px", padding: "5px", width: "15%" }}
              >
                <option key='' value=''> Select GST Rate </option>

                {gstRates.map((group) => (
                  <option key={group.GstRateCode} value={group.GSTPercent}>
                    {group.GSTName}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={GstRateCode}
                onChange={(e) => {
                  const entereditemCode = parseInt(e.target.value, 10);
                  setGstRateCode(entereditemCode);
                  const selectedGroupCode = gstRates.find(
                    (group) => group.GSTRateCode == entereditemCode
                  );
                  if (selectedGroupCode) {
                    setGstRate(selectedGroupCode.GSTPercent);
                  } else {
                    setGstRate("");
                  }
                }}
                readOnly
                placeholder="GstCode"
                style={{
                  marginLeft: "10px",
                  marginBottom: "5px",
                  padding: "4px",
                  width: "8%",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="QtyPerBox"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                QtyPerBox
              </label>
              <input
                type="number"
                value={QtyPerBox}
                onChange={(e) => setQtyPerBox(e.target.value)}
                placeholder="QtyPerBox"
                style={{ marginBottom: "5px", padding: "5px", width: "15%" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="CostRate"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                CostRate
              </label>
              <input
                type="number"
                value={CostRate}
                onChange={(e) => setCostRate(e.target.value)}
                placeholder="CostRate"
                style={{ marginBottom: "5px", padding: "5px", width: "15%" }}
              />
            </div>

            {/* <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="OpStock"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                OpStock
              </label>
              <input
                type="number"
                value={BufferStock}
                onChange={(e) => setBufferStock(e.target.value)}
                placeholder="Opening Stock"
                style={{ marginBottom: "5px", padding: "5px", width: "15%" }}
              />
            </div> */}

            <div
              style={{
                display: "flex",
                marginBottom: "5px",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="Remark1"
                style={{
                  width: "150px",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Remark1
              </label>
              <input
                type="text"
                value={Remark1}
                onChange={(e) => setRemark1(e.target.value)}
                placeholder="Remark1"
                style={{ marginBottom: "5px", padding: "5px", width: "40%" }}
              />
            </div>
          </div>
          <div>
            <button
              className={formMode === "add" ? "add-button" : "update-button"}
              onClick={formMode === "add" ? addItem : () => updateItem(ItCode)}
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: formMode === "add" ? "#4caf50" : "#2196f3",
                color: "white",
                border: "none",
                cursor: "pointer",
                marginBottom: "10px", borderRadius: '5px'
              }}
            >
              {formMode === "add" ? "Add" : "Update"}
            </button>
            <button
              className="view-button"
              onClick={handleCancel}
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                cursor: "pointer",
                marginLeft: "10px",
                marginBottom: "10px", borderRadius: '5px'
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: "100%" }}>
          <select
            value={selectedSubGroup}
            onChange={(e) => setSelectedSubGroup(e.target.value)}
            style={{ marginBottom: "2px", padding: "5px" }}
          >
            <option value="">All Sub Groups</option>
            {uniqueSubGroups.map((group) => (
              <option key={group.code} value={group.code}>
                {group.name}
              </option>
            ))}
          </select>
          <div style={{ maxHeight: "520px", overflowY:"auto", width:"100%", display:"block" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #ccc",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2", color: "black" }}>
                  <th
                    style={headerCellStyle}
                  >
                    ItCode
                  </th>
                  <th
                    style={headerCellStyle}
                  >
                    Item SubGroup
                  </th>
                  <th
                    style={headerCellStyle}
                  >
                    Item Name
                  </th>
                  <th
                    style={headerCellStyle}
                    className="print-hide"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemMasterEntries
                  .filter(item =>
                    selectedSubGroup === "" || item.ItemSubGroupCode == selectedSubGroup
                  ).filter((item, index, self) =>
                    index === self.findIndex(t => t.ItCode === item.ItCode)
                  ).sort((a, b) => b.ItCode - a.ItCode).map((item) => {
                    const grade = itemSubGroup.find(entry => entry.ItemSubGroupCode == item.ItemSubGroupCode)?.ItemSubGroupName;
                    return (
                      <tr
                        key={item.ItCode}
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          textAlign: "center",
                        }}
                      >
                        <td style={cellStyle}>
                          {item.ItCode}
                        </td>
                        <td style={{...cellStyle, textAlign: 'left'}}>
                          {grade}
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'left' }}>
                          {item.ItName}
                        </td>
                        <td className="print-hide" style={{ border: "1px solid #ccc" }}>
                          <button
                            className='action-btn btn-edit'
                            onClick={() => setEditForm(item)}
                          >
                            Edit
                          </button>
                          <button
                            className='action-btn btn-delete'
                            onClick={() => {
                              setDeleteEntryNo({ ItCode: item.ItCode });
                              setOpenConfirmation(true);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          </div>
          <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setOpenConfirmation(false)}
                color="inherit"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleDeleteConfirmation()}
                color="error"
                autoFocus
              >
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity="error"
          sx={{ fontSize: "16px" }}
          onClose={handleCloseSnackbar}
        >
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ItemMaster;
